import { Container } from "reactstrap";
import "./PlaceMentRecord.css";

const defaultPlacements = [
    {
        image: "/placements/Altron.jpe",
        company: "Altron",
    },
    {
        image: "/placements/ASM%20Tech.webp",
        company: "ASM Tech",
    },
    {
        image: "/placements/autodesk%20naveen.webp",
        company: "Autodesk",
    },
    {
        image: "/placements/Bhavani-Shankar.jpe",
        company: "Kennametal",
    },
    {
        image: "/placements/Donaldson.webp",
        company: "Donaldson",
    },
    {
        image: "/placements/Ford.webp",
        company: "Ford",
    },
    {
        image: "/placements/Haldor%20Topsoe.webp",
        company: "Haldor Topsoe",
    },
    {
        image: "/placements/Icube%20logics.jpe",
        company: "iCube Logics",
    },
    {
        image: "/placements/ITC%20Infotech.webp",
        company: "ITC Infotech",
    },
    {
        image: "/placements/Prasanna-Donaldson.webp",
        company: "Donaldson",
    },
    {
        image: "/placements/TechMahindra.webp",
        company: "Tech Mahindra",
    },
    {
        image: "/placements/VivekBalakrishnan-TATA.jpe",
        company: "TATA",
    },
];

function PlaceMentRecord({
    title = "Where Our Students Are Now",
    description = "A proven track record of transforming CAD Engineers into high-paying CAD Automation & Customization professionals at leading companies.",
    placements = defaultPlacements,
}) {
    if (!placements || placements.length === 0) {
        return null;
    }

    // Duplicate cards for seamless infinite scrolling
    const scrollingPlacements = [
        ...placements,
        ...placements,
    ];

    return (
        <section className="placement-section">

            <Container fluid>

                {/* Header */}
                <div className="placement-header">

                    <h2 className="placement-title">
                        {title}
                    </h2>

                    <p className="placement-description">
                        {description}
                    </p>

                </div>


                {/* Slider */}
                <div className="placement-slider">

                    <div className="placement-track">

                        {scrollingPlacements.map(
                            (placement, index) => (

                                <div
                                    className="placement-card"
                                    key={`${placement.company}-${index}`}
                                >

                                    {/* Image */}
                                    <div className="placement-image-wrapper">

                                        <img
                                            src={placement.image}
                                            alt={`${placement.company} placement`}
                                            className="placement-image"
                                            loading="lazy"
                                        />

                                    </div>


                                    {/* Company */}
                                    <div className="placement-company">

                                        <span>
                                            {placement.company}
                                        </span>

                                    </div>

                                </div>
                            )
                        )}

                    </div>

                </div>

            </Container>

        </section>
    );
}

export default PlaceMentRecord;